/* eslint-disable react/react-in-jsx-scope */
import { Route } from 'react-router-dom';
import { PrivateRoute } from '~/main/routes/PrivateRoute';

import {
  MakeListAdministratorPage,
  MakeListManagePage,
  MakeListParticipantPage,
  MakeListProfessionalPage,
  MakeRegisterManagerPage,
  MakeRegisterProfessionalPage,
} from '~/main/factories/pages/user';

import SectorsFactory from '~/main/factories/pages/sectors/SectorsFactory';

import { BillingFactory } from '~/main/factories/pages/billing';

import { CreateOrgUnitFactory } from '~/main/factories/pages/createOrgUnit';
import { OrgUnitDetailFactory } from '~/main/factories/pages/orgUnitDetail';
import { RegisterFactory } from '~/main/factories/pages/register';

import { InviteProfessionalFactory } from '~/main/factories/pages/inviteProfessional';

import AuditRecordFactory from '../factories/pages/AuditRecord';
import { EditOrgUnitFactory } from '../factories/pages/editOrgUnit';
import {
  MakePerfilFactories,
  MakeProfileFactories,
} from '../factories/pages/profile';

const RoutesUser = [
  <PrivateRoute path="/profile" exact component={MakeProfileFactories} />,
  <PrivateRoute path="/profile/:userId" component={MakePerfilFactories} />,

  <PrivateRoute
    path="/administrator"
    exact
    component={MakeListAdministratorPage}
  />,
  <PrivateRoute path="/administrator/register" component={RegisterFactory} />,
  <PrivateRoute path="/manager" exact component={MakeListManagePage} />,
  <PrivateRoute path="/manager/register" component={MakeRegisterManagerPage} />,
  <PrivateRoute path="/administrator/billing" component={BillingFactory} />,
  <PrivateRoute
    path="/administrator/newsector"
    component={CreateOrgUnitFactory}
  />,
  <PrivateRoute
    path="/administrator/editsector"
    component={EditOrgUnitFactory}
  />,
  <PrivateRoute path="/administrator/sectors" component={SectorsFactory} />,
  <PrivateRoute
    path="/administrator/orgdetail"
    component={OrgUnitDetailFactory}
  />,
  <PrivateRoute
    path="/participant"
    exact
    component={MakeListParticipantPage}
  />,
  <PrivateRoute path="/participant/register" component={RegisterFactory} />,

  <PrivateRoute
    path="/professional"
    exact
    component={MakeListProfessionalPage}
  />,

  <Route path="/invite" exact component={InviteProfessionalFactory} />,

  <PrivateRoute
    path="/professional/register"
    component={MakeRegisterProfessionalPage}
  />,

  <Route path="/user/register" component={RegisterFactory} />,

  <PrivateRoute
    exact
    path="/administrator/audit"
    component={AuditRecordFactory}
  />,
];

export default RoutesUser;
